import { UseShareDataPropsType, UseShareDataReturn } from '@type/web/share';

import useShareDataPopUpV1 from './useShareDataPopUpV1';
import useShareDataPopUpV2 from './useShareDataPopUpV2';
import useShareDataPopUpV3 from './useShareDataPopUpV3';

export enum ModalType {
  V1 = 1,
  V2,
  V3,
}

export interface ShareDataPropsType extends UseShareDataPropsType {
  modalType?: ModalType;
}

/**
 *
 * @param data 공유할 데이터
 * @param defaultData 공유할 데이터 기본값
 * @param shareMessage 공유할 때 보여줄 메시지
 * @param modalType 모달 디자인 타입
 * @returns 공유하기 팝업 컴포넌트, 공유하기 팝업 닫기 함수
 */
export default function useShareDataPopUp({
  data,
  defaultData,
  shareMessage = '친구들에게 공유하기!',
  modalType = ModalType.V1,
}: ShareDataPropsType): UseShareDataReturn {
  const useShareDataPopUpList = {
    [ModalType.V1]: useShareDataPopUpV1,
    [ModalType.V2]: useShareDataPopUpV2,
    [ModalType.V3]: useShareDataPopUpV3,
  };

  const { SharePopUpComponent, onShowPopUp } = useShareDataPopUpList[modalType](
    {
      data,
      defaultData,
      shareMessage,
    },
  );

  return { SharePopUpComponent, onShowPopUp };
}
